/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MediqPaymentMethod } from './MediqPaymentMethod';
import {
    MediqPaymentMethodFromJSON,
    MediqPaymentMethodFromJSONTyped,
    MediqPaymentMethodToJSON,
} from './MediqPaymentMethod';

/**
 * Representation of a Payment Mode
 * @export
 * @interface PaymentMode
 */
export interface PaymentMode {
    /**
     * Payment mode code
     * @type {string}
     * @memberof PaymentMode
     */
    code?: string;
    /**
     * Payment mode name
     * @type {string}
     * @memberof PaymentMode
     */
    name?: string;
    /**
     * Payment mode description
     * @type {string}
     * @memberof PaymentMode
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMode
     */
    paymentProvider?: string;
    /**
     * 
     * @type {Array<MediqPaymentMethod>}
     * @memberof PaymentMode
     */
    paymentMethods?: Array<MediqPaymentMethod>;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMode
     */
    eligibleForPbs?: boolean;
}

/**
 * Check if a given object implements the PaymentMode interface.
 */
export function instanceOfPaymentMode(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaymentModeFromJSON(json: any): PaymentMode {
    return PaymentModeFromJSONTyped(json, false);
}

export function PaymentModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'paymentProvider': !exists(json, 'paymentProvider') ? undefined : json['paymentProvider'],
        'paymentMethods': !exists(json, 'paymentMethods') ? undefined : ((json['paymentMethods'] as Array<any>).map(MediqPaymentMethodFromJSON)),
        'eligibleForPbs': !exists(json, 'eligibleForPbs') ? undefined : json['eligibleForPbs'],
    };
}

export function PaymentModeToJSON(value?: PaymentMode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
        'description': value.description,
        'paymentProvider': value.paymentProvider,
        'paymentMethods': value.paymentMethods === undefined ? undefined : ((value.paymentMethods as Array<any>).map(MediqPaymentMethodToJSON)),
        'eligibleForPbs': value.eligibleForPbs,
    };
}

